<template>
  <responsive-modal v-model="visible">
    <div class="tool-modal-enotas p-5">
      <button class="btn text-secondary close" @click="visible = false">
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração eNotas
        </strong>
      </div>
      <div class="d-flex align-items-center mb-5">
        <small class="text-dark flex-fill mt-5">
          <a
            target="_blank"
            href="https://enotas.com.br/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça o eNotas
          </a>
        </small>
      </div>
      <hr />
      <action-dispatcher
        action="integration/getCoproducerProducts"
        :parameters="{ limit: 500 }"
      >
        <form-group
          slim
          select
          id="product-select"
          v-model="form.product_id"
          label="Nome do produto"
          placeholder="Selecionar produto..."
          :disabled="form.id != null"
          :errors="errors.product_id"
          :options="
            coproducerProducts.map(product => ({
              id: product.product_id,
              name: product.product_name
            }))
          "
        />
      </action-dispatcher>
      <form-group
        id="token"
        label="Token"
        v-model="form.token"
        placeholder="Digite o token da integração..."
        :errors="errors.token"
      />
      <form-group
        type="radio"
        id="select-send-invoice"
        label="Quando enviar notas:"
        v-model="form.when_generate_nfe"
        :options="nfeOptions"
        :errors="errors.when_generate_nfe"
      />
      <form-group
        isSwitch
        id="switch-send-nfe"
        v-model="form.send_nfe_for_client"
        label="Enviar nota para o cliente?"
        :errors="errors.send_nfe_for_client"
      />
      <form-group
        isSwitch
        id="is_split"
        v-model="form.is_split"
        label="Divisão de notas ao coprodutor?"
        :errors="errors.is_split"
      />
      <div class="d-flex justify-content-center mt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'btn-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "product_id",
          "token",
          "when_generate_nfe",
          "send_nfe_for_client",
          "is_split"
        ],
        {
          send_nfe_for_client: false,
          is_split: false
        }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      } else {
        this.validateCNPJ();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("integration", ["coproducerProducts"]),
    isValid() {
      return (
        this.form.product_id &&
        this.form.token &&
        this.validDocument &&
        this.form.when_generate_nfe !== undefined // necessário comparar com undefined porque o valor pode ser "0"
      );
    },
    nfeOptions() {
      return [
        { id: "0", name: "Emitir nota no ato da venda" },
        { id: "1", name: "Emitir nota depois quando garantia acabar" },
        { id: "2", name: "Não emitir a nota" }
      ];
    }
  },
  methods: {
    clear() {
      this.form = {
        send_nfe_for_client: false,
        is_split: false
      };
      this.$emit("clear-edit");
    },
    onSubmit() {
      this.loading = false;
      this.visible = false;
      this.$emit("update-list");
    },
    submit() {
      this.loading = true;
      let data = { ...this.form };
      let action = this.integrationToEdit
        ? "integration/putIntegration"
        : "integration/postIntegration";
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("Integração salva");
          this.onSubmit();
        })
        .catch(error => {
          this.$message.error("Erro ao salvar integração");
          this.errors = error.response.data;
          this.loading = false;
        })
        .finally(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-enotas {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 28px;
    }
  }
}
</style>
